import React from "react";
import { StyleSheet, View } from "react-native";

//Custom Imports
import color from "@constants/color";
import t from "@constants/localization";
import { CONTEST_TYPES } from "../ContestEvents";
import CustomText from "@components/CustomText";
import FetchCMSEntity from "@components/CMS/FetchCMSEntity";
import { CONTEST_EVENTS } from "@constants/analyticsEventsCT";

const PATH = "screens/Contest/contestDetails";

const ContestRules = ({ item = {}, trackEvent = () => {} }) => {
  const { contest_rules_cms_item_id = "", contest_type = "" } = item;

  const onPressRules = (event) => {
    trackEvent(CONTEST_EVENTS.CONTEST_RULES_CLICKED, {
      screen: "Contest details page",
      contest_type: CONTEST_TYPES[contest_type],
      cms_id: contest_rules_cms_item_id,
      banner_type: "video",
      events: event,
    });
  };
  return (
    <View style={styles.container}>
      <CustomText
        variant="subtitle_16"
        newfont={true}
        numberOfLines={1}
        style={styles.titleText}
      >
        {t(`${PATH}/contestRules`)}
      </CustomText>
      <FetchCMSEntity
        trackEvent={onPressRules}
        id={contest_rules_cms_item_id}
        type="BANNER_CAROUSEL"
        isPaddingVertical={false}
      />
    </View>
  );
};

export default ContestRules;

const styles = StyleSheet.create({
  container: {
    backgroundColor: color.white,
    paddingHorizontal: 16,
    marginTop: 15,
  },
  titleText: {
    color: color.mediumBlack,
  },
});
